import { twMerge } from 'tailwind-merge';
import type { FinalPhaseTeamData } from './KnockoutFinalPhase.types';
import GoalscorerLastMatch from './GoalscorerLastMatch';
import JerseyWithMissingPlayers from './JerseyWithMissingPlayers';

interface KnockoutFinalPhaseProps {
  /** Home team data. */
  home: FinalPhaseTeamData;
  /** Away team data. */
  away: FinalPhaseTeamData;
  /** Localized heading for the goalscorer section when visible, provided by the parent. */
  goalscorerLastMatchLabel: string;
  /** Localized label for the missing-players block under each jersey, provided by the parent. */
  missingPlayersLabel: string;
  /** When true, shows "Goalscorer last match" section (variant B). */
  showGoalscorers?: boolean;
  /** Optional className for the root wrapper. */
  className?: string;
}

export default function KnockoutFinalPhase({
  home,
  away,
  goalscorerLastMatchLabel,
  missingPlayersLabel,
  showGoalscorers = false,
  className = '',
}: KnockoutFinalPhaseProps) {
  return (
    <div className={twMerge('flex flex-col gap-[16px] pb-[8px] px-[8px]', className)}>
      {showGoalscorers && (
        <GoalscorerLastMatch
          label={goalscorerLastMatchLabel}
          homeScorers={home.goalscorers ?? []}
          awayScorers={away.goalscorers ?? []}
        />
      )}
      <div className="flex">
        <div className="flex-1 min-w-0">
          <JerseyWithMissingPlayers
            jerseySrc={home.jerseySrc}
            missingPlayers={home.missingPlayers}
            missingPlayersLabel={missingPlayersLabel}
          />
        </div>
        <div className="flex-1 min-w-0">
          <JerseyWithMissingPlayers
            jerseySrc={away.jerseySrc}
            missingPlayers={away.missingPlayers}
            missingPlayersLabel={missingPlayersLabel}
          />
        </div>
      </div>
    </div>
  );
}
